import { configureStore } from "@reduxjs/toolkit";
import itemsReducer from "./itemStore";
import appReducer from "./appStore";
//* creating a central store
const centralStore = configureStore({ reducer: { items: itemsReducer, app: appReducer } });

export default centralStore;
